import { Link } from 'react-router-dom';
import type { Person } from '../../lib/peopleApi';
import { UtilizationBar, initials } from './UtilizationBar';

interface PersonCardProps {
  person: Person;
}

export function PersonCard({ person }: PersonCardProps) {
  // Show projects that are currently allocated (no end date or end in future).
  const now = Date.now();
  const currentProjects = person.allocations
    .filter((a) => !a.endDate || new Date(a.endDate).getTime() >= now)
    .map((a) => a.project.name);

  return (
    <Link
      to={`/people/${person.id}`}
      className="block rounded-lg border border-gray-200 bg-white p-4 shadow-sm transition hover:shadow-md"
    >
      <div className="flex items-center gap-3">
        {person.avatarUrl ? (
          <img
            src={person.avatarUrl}
            alt={person.fullName}
            className="h-12 w-12 rounded-full object-cover"
          />
        ) : (
          <div className="flex h-12 w-12 items-center justify-center rounded-full bg-brand-600 text-sm font-semibold text-white">
            {initials(person.fullName)}
          </div>
        )}
        <div className="min-w-0">
          <h3 className="truncate font-semibold text-gray-900">{person.fullName}</h3>
          <p className="truncate text-sm text-gray-500">{person.title ?? '—'}</p>
        </div>
      </div>

      <p className="mt-3 truncate text-sm text-gray-600">{person.email}</p>
      {person.department && (
        <span className="mt-2 inline-block rounded bg-gray-100 px-2 py-0.5 text-xs text-gray-600">
          {person.department}
        </span>
      )}

      {currentProjects.length > 0 && (
        <p className="mt-3 truncate text-xs text-gray-500">
          Proiecte: {currentProjects.join(', ')}
        </p>
      )}

      <div className="mt-3">
        <UtilizationBar percent={person.utilizationPercent} />
      </div>
    </Link>
  );
}
